import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { OverviewField } from '@/components/OverviewField';
import { TabContextProvider } from './TabContext';
import { TabHeaderName } from './TabHeaderName';
import { DealSubtitle } from './DealSubtitle';
import { PolicyTotal } from './PolicyTotal';
import { ClientIncome } from './ClientIncome';
import { ContactDetails } from './ContactDetails';

export const TabHeader = ({ subtitle, icon, isPreview = false, sx = { px: 3 } }) => {
	const { dealRow, isClientView: isClient, isRelationshipCompanyView } = useObjectContext();

	const isClaim = dealRow?.pipeline === process.env.REACT_APP_PIPELINE_CLAIMS;
	const isNewBusiness = dealRow?.pipeline === process.env.REACT_APP_PIPELINE_NEW_BUSINESS;
	const showRecordSubtitle = isClient || isRelationshipCompanyView;

	return (
		<Box display='flex' width='100%' sx={{ alignItems: 'center', ...sx }}>
			<TabContextProvider>
				<Stack width='100%' spacing={1}>
					<Stack direction='row' alignItems='center' width='100%' spacing={1}>
						{icon && icon}
						<Stack width='100%'>
							<TabHeaderName />
							{showRecordSubtitle ? (
								<Stack
									role='heading'
									aria-level='2'
									direction='row'
									alignItems='center'
									spacing={3}
								>
									<Typography role='heading' aria-level='2' variant='body1'>
										{subtitle}
									</Typography>
								</Stack>
							) : (
								<DealSubtitle />
							)}
						</Stack>
					</Stack>
					{!isClaim && !isRelationshipCompanyView && <OverviewField />}
					{!isPreview && isNewBusiness && <PolicyTotal />}
					{!isPreview && isClient && <ClientIncome />}
					{(isPreview || isRelationshipCompanyView) && <ContactDetails />}
				</Stack>
			</TabContextProvider>
		</Box>
	);
};

export default TabHeader;
